module.exports = __webpack_public_path__ + "static/sigma-3_PLACEHOLDER-14e336dc105fca8ddce5f4ff079f74f5.jpg";